import { render, staticRenderFns } from "./NotesCabinet.vue?vue&type=template&id=2ff82268&"
import script from "./NotesCabinet.vue?vue&type=script&lang=js&"
export * from "./NotesCabinet.vue?vue&type=script&lang=js&"
import style0 from "./NotesCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports